import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faInfoCircle, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'

import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import {
  useNavigate,
} from 'react-router'
import {
  Link,
  useParams,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  SchedulesCtx,
} from '../schedules'
import {
  appRouter,
  C,
  defaultBanksQueryTmpl,
  logg,
  useApiRouter,
} from '$shared'

import {
  AppCtx,
} from '$src/App'
import {
  BanksCtx,
} from '$src/components/banks'

import {
  defaultSavedQuery,
  QueriesCtx,
} from '.'

library.add( faFilter, faInfoCircle, faSearch, faTimes )

/**
 * QueryModal
 * For: create new list, modify list. 2025-07-01
**/
const QueryModal = (props) => {
  // logg(props, 'QueryModal')

  /* ctx */

  const apiRouter = useApiRouter()
  const navigate  = useNavigate()

  // const params = useParams()
  // const {
  //   query_id,
  // } = params
  // logg(params, 'params in QueryModal')

  const {
    actionName, setActionName,
    loading,    setLoading,
    selectedResource, setSelectedResource,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in QueryModal')

  const {
    query,          setQuery,
    results,        setResults,
    resultsTitle,   setResultsTitle,
    selectedBanks,  setSelectedBanks,
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'BanksCtx in QueryModal')

  const {
    queryModalOpen, setQueryModalOpen,
    queriesList,      setQueriesList,      refreshQueriesList,
    queriesModalOpen, setQueriesModalOpen,
    savedQuery,     setSavedQuery,
    selectedQueries,    setSelectedQueries,
  } = useContext(QueriesCtx)
  // logg(useContext(QueriesCtx), 'QueriesCtx in QueryModal')

  const {
    oneResultTitle, setOneResultTitle, defaultOneResultTitle,
  } = useContext(SchedulesCtx)

  /* state */



  /* effects */

  const [ modalTitle, setModalTitle ] = useState('Save Query')
  useEffect(() => {
    switch (actionName) {
      case C.lists_actions.add_to_new:
        setModalTitle('Create New List')
        break
      case C.lists_actions.modify:
        setModalTitle('Modify List')
        break
      case C.queries_actions.modify:
        setModalTitle('Edit Query')
        break
      case C.queries_actions.rename:
        setModalTitle('Rename Query')
        break
    }
  }, [ actionName, queryModalOpen ])

  /* methods */

  const handleSave = () => {
    setLoading(true)
    let promise;

    switch (actionName) {
      case C.lists_actions.add_to_new:
        promise = fetch(apiRouter.listsPath(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            list: { ...savedQuery,
              items: Object.keys(selectedBanks),
            },
          }),
        })
        break

      case C.queries_actions.create:
        promise = fetch(apiRouter.queriesPath(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: savedQuery,
          }),
        })
        break

      case C.queries_actions.modify:
      case C.lists_actions.modify:
        // logg(savedQuery, 'savedQuery')

        promise = fetch(apiRouter.queryPath({ id: savedQuery.id }), {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: savedQuery,
            action: actionName,
          }),
        })
        break

      case C.queries_actions.rename:
        promise = fetch(apiRouter.queryPath({ id: savedQuery.id }), {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: savedQuery,
            action: actionName,
          }),
        })
        break

      default:
        throw '361 - this should never happen.'
    }
    promise.then(r => r.json()).then(inns => {
      toast(`Successfully ${savedQuery.id ? 'saved' : 'created'} list or query.`)
      refreshQueriesList()
      setQueryModalOpen(false)
      setQueriesModalOpen(false)
      setResults([])
      setResultsTitle(null)
      setOneResultTitle(defaultOneResultTitle)
      navigate('/')
      setSelectedBanks({})
      setSavedQuery(defaultSavedQuery)
      setQuery(defaultBanksQueryTmpl)
    }).catch((err) => {
      logg(err, 'could not save Query')
      toast("We're sorry, but something went wrong. Please try again later.")
    }).finally(() => {
      setLoading(false)
      setSelectedQueries({})
      setSelectedResource({})
      setSavedQuery({})
    })
  }

  return <Modal
    ariaHideApp={false}
    className="ListModal BaseModal"
    isOpen={queryModalOpen}
    onRequestClose={ () => setQueryModalOpen(false) }
    overlayClassName="ModalOverlay-z10"
  >
    <div className='header'>
      <h5 >{ modalTitle }</h5>
      <div className='right'>
        <Link to='/' style={{ color: '#666' }} ><div className='close' style={{ width: '30px' }} onClick={() => {
          setQueryModalOpen(false) ;
        } }><FontAwesomeIcon icon="fa-solid fa-times"
          style={{ cursor: 'pointer' }}
        /></div></Link>
      </div>
    </div>

    <div className='container'>
      <div className='row mt-3'>
        <div className='col-md-2'></div>
        <div className='col-md-8'>
          <div className='field'>
            <label>Name</label>&nbsp;
            <input type='text' value={savedQuery.name} onChange={(ev) => setSavedQuery({ ...savedQuery, name: ev.target.value }) } />
          </div>
        </div>
      </div>
      { actionName === C.queries_actions.rename ? null : <div className='field-checkbox'>
        <input type='checkbox' checked={savedQuery.is_merge} onChange={(ev) => setSavedQuery({ ...savedQuery, is_merge: ev.target.checked }) } />
        <label>Merged</label>
      </div> }
    </div>

    <div className='actions'>
      <div className='left'></div>
      <div className='right'>
        <input type='button' disabled={loading} className='Btn btn-primary' onClick={handleSave}
          value={loading ? '...' : "Save"} />
      </div>
    </div>

  </Modal>

}
export default QueryModal
